/**
 * @class {T.Form.Select}
 * @extends {T.Form.Base}
 * @param {T.Form.Select.Par|Object} par
 */
T.Form.Select = Class(
	/**
	 * @lends {T.Form.Select#}
	 */
	{
		__NAME: 'T.Form.Select',
		_isOpened: false,
		_options: {},
		_drawCaption: null,
		initialized: false,

		/**
		 * @param {T.Form.Select.Par|Object} par
		 * @constructs
		 */
		__construct: function(par){
			this._change = par.onChange || D.doNothing;
			if (par.drawCaption) {
				this._drawCaption = par.drawCaption;
			}

			this.node = mkE({
				tag: 'div',
				className: 'select',
				els: [
					this._captionNode = mkE({
						tag: 'label',
						className: 'hidden'
					}),
					this._itemNode = mkE({
						tag: 'div',
						className: 'select-container',
						els: [
							this._valueText = mkE({
								tag: 'div',
								className: 'select-value'
							}),
							this._select = mkE({
								tag: 'select',
								className: 'form-control',
								name: par.name || '',
								prop: {
									onchange: this._onChange
								}
							})
						]
					}),
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.border ){
				addClassName(this.node, 'select-border');
			}

			if( par.dark ){
				addClassName(this.node, 'select-dark');
			}

			if( par.small ){
				addClassName(this.node, 'select-small');
			}

			if( par.options ) {
				this.options(par.options);
			}

			this._par(par);
			if( isset(par.value) ) {
				this.value(par.value);
			}
			this.initialized = true;
		},

		value: function(v, onChange = true){
			if( isset(v) ){
				this._select.value = v;
				if( onChange ) {
					this._onChange(v);
				}
			}
			return this._select.value;
		},

		options(options) {
			clearNode(this._select);
			this._options = [];
			for( let i = 0, l = options.length; i < l; i++ ){
				let option = options[i];
				mkE({
					tag: 'option',
					attr: {
						value: option.value
					},
					text: option.caption
				}).append(this._select);
				this._options[String(option.value)] = option.caption;
			}
		},

		_onChange: function(value){
			if (value instanceof Event) {
				value = this._select.value;
			}
			if (this._drawCaption) {
				clearNode(this._valueText);
				mkE.appendTypeElement(this._valueText, this._drawCaption(value));
			} else {
				setNodeText(this._valueText, this._options[String(value)]);
			}
			if( this.initialized ){
				this._change();
			}
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.Select.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.Select.Par = Class(
	/**
	 * @lends {T.Form.Select.Par#}
	 */
	{
		__NAME: 'T.Form.Select.Par',

		value: null,
		onChange: D.doNothing,
		border: false,
		dark: false,
		options: [],
		name: null,
		drawCaption: null,
		small: false,
	},
	T.Form.Base.Par
);
